<template>
  <div class="diferenciais-page">
    <HomeHeader />

    <!-- Hero Section com Efeito Parallax -->
    <section class="hero-section">
      <div class="parallax-container">
        <div class="overlay"></div>
        <h1 class="hero-title">{{ t('differentials.heroTitle') }}</h1>
        <div class="hero-subtitle">{{ t('differentials.heroSubtitle') }}</div>
      </div>
    </section>

    <!-- Seção de Introdução -->
    <section class="intro-section">
      <div class="watermark-side watermark-side-left"></div>
      <div class="container">
        <ScrollReveal direction="bottom" :delay="100">
          <div class="section-title">
            <span class="accent-line"></span>
            <h2>{{ t('differentials.introTitle') }}</h2>
            <span class="accent-line"></span>
          </div>
          <p class="intro-text" v-html="t('differentials.introText')"></p>
        </ScrollReveal>
      </div>
    </section>

    <!-- Seção de Diferenciais -->
    <section class="features-section">
      <div class="container">
        <div class="features-grid">
          <ScrollReveal direction="left" :delay="200">
            <div class="feature-card">
              <div class="feature-icon-wrapper">
                <i class="fas fa-warehouse"></i>
              </div>
              <div class="feature-content">
                <h3>{{ t('differentials.features.inventory.title') }}</h3>
                <p>{{ t('differentials.features.inventory.description') }}</p>
                <ul class="feature-list">
                  <li><span class="highlight">{{ t('differentials.features.inventory.feature1') }}</span> {{
                    t('differentials.features.inventory.feature1Description') }}</li>
                  <li><span class="highlight">{{ t('differentials.features.inventory.feature2') }}</span> {{
                    t('differentials.features.inventory.feature2Description') }}</li>
                </ul>
              </div>
            </div>
          </ScrollReveal>

          <ScrollReveal direction="right" :delay="300">
            <div class="feature-card">
              <div class="feature-icon-wrapper">
                <i class="fas fa-truck"></i>
              </div>
              <div class="feature-content">
                <h3>{{ t('differentials.features.logistics.title') }}</h3>
                <p>{{ t('differentials.features.logistics.description') }}</p>
                <ul class="feature-list">
                  <li><span class="highlight">{{ t('differentials.features.logistics.feature1') }}</span> {{
                    t('differentials.features.logistics.feature1Description') }}</li>
                  <li><span class="highlight">{{ t('differentials.features.logistics.feature2') }}</span> {{
                    t('differentials.features.logistics.feature2Description') }}</li>
                </ul>
              </div>
            </div>
          </ScrollReveal>

          <!-- <ScrollReveal direction="left" :delay="400">
            <div class="feature-card">
              <div class="feature-icon-wrapper">
                <i class="fas fa-building"></i>
              </div>
              <div class="feature-content">
                <h3>{{ t('differentials.features.expansion.title') }}</h3>
                <p>{{ t('differentials.features.expansion.description') }}</p>
                <ul class="feature-list">
                  <li><span class="highlight">{{ t('differentials.features.expansion.feature1') }}</span> {{
                    t('differentials.features.expansion.feature1Description') }}</li>
                  <li><span class="highlight">{{ t('differentials.features.expansion.feature2') }}</span> {{
                    t('differentials.features.expansion.feature2Description') }}</li>
                </ul>
              </div>
            </div>
          </ScrollReveal> -->

          <ScrollReveal direction="right" :delay="500">
            <div class="feature-card">
              <div class="feature-icon-wrapper">
                <i class="fas fa-star"></i>
              </div>
              <div class="feature-content">
                <h3>{{ t('differentials.features.quality.title') }}</h3>
                <p>{{ t('differentials.features.quality.description') }}</p>
                <ul class="feature-list">
                  <li><span class="highlight">{{ t('differentials.features.quality.feature1') }}</span> {{
                    t('differentials.features.quality.feature1Description') }}</li>
                  <li><span class="highlight">{{ t('differentials.features.quality.feature2') }}</span> {{
                    t('differentials.features.quality.feature2Description') }}</li>
                </ul>
              </div>
            </div>
          </ScrollReveal>
        </div>
      </div>
    </section>

    <!-- Seção de Métricas/Indicadores -->
    <section class="metrics-section">
      <div class="container">
        <ScrollReveal direction="bottom" :delay="200">
          <div class="section-title light">
            <span class="accent-line"></span>
            <h2>{{ t('differentials.metricsTitle') }}</h2>
            <span class="accent-line"></span>
          </div>
        </ScrollReveal>

        <div class="metrics-grid">
          <ScrollReveal direction="bottom" :delay="300">
            <div class="metric-card">
              <div class="metric-icon">
                <i class="fas fa-shipping-fast"></i>
              </div>
              <div class="metric-number">{{ t('differentials.metrics.delivery.number') }}</div>
              <div class="metric-label">{{ t('differentials.metrics.delivery.label') }}</div>
            </div>
          </ScrollReveal>

          <ScrollReveal direction="bottom" :delay="400">
            <div class="metric-card">
              <div class="metric-icon">
                <i class="fas fa-check-circle"></i>
              </div>
              <div class="metric-number">{{ t('differentials.metrics.accuracy.number') }}</div>
              <div class="metric-label">{{ t('differentials.metrics.accuracy.label') }}</div>
            </div>
          </ScrollReveal>

          <ScrollReveal direction="bottom" :delay="500">
            <div class="metric-card">
              <div class="metric-icon">
                <i class="fas fa-smile"></i>
              </div>
              <div class="metric-number">{{ t('differentials.metrics.satisfaction.number') }}</div>
              <div class="metric-label">{{ t('differentials.metrics.satisfaction.label') }}</div>
            </div>
          </ScrollReveal>

          <ScrollReveal direction="bottom" :delay="600">
            <div class="metric-card">
              <div class="metric-icon">
                <i class="fas fa-map-marked-alt"></i>
              </div>
              <div class="metric-number">{{ t('differentials.metrics.coverage.number') }}</div>
              <div class="metric-label">{{ t('differentials.metrics.coverage.label') }}</div>
            </div>
          </ScrollReveal>
        </div>
      </div>
    </section>

    <!-- Seção de Depoimentos -->
    <!-- <section class="testimonials-section">
      <div class="container">
        <ScrollReveal direction="bottom" :delay="200">
          <div class="section-title">
            <span class="accent-line"></span>
            <h2>{{ t('differentials.testimonialsTitle') }}</h2>
            <span class="accent-line"></span>
          </div>
        </ScrollReveal>

        <div class="testimonials-grid">
          <ScrollReveal direction="left" :delay="300">
            <div class="testimonial-card">
              <div class="testimonial-content">
                <i class="fas fa-quote-left quote-icon"></i>
                <p>{{ t('differentials.testimonials.testimonial1.text') }}</p>
                <div class="testimonial-author">
                  <div class="author-avatar">
                    <span>{{ t('differentials.testimonials.testimonial1.authorInitials') }}</span>
                  </div>
                  <div class="author-info">
                    <h4>{{ t('differentials.testimonials.testimonial1.authorName') }}</h4>
                    <p>{{ t('differentials.testimonials.testimonial1.authorPosition') }}</p>
                  </div>
                </div>
              </div>
            </div>
          </ScrollReveal>

          <ScrollReveal direction="right" :delay="400">
            <div class="testimonial-card">
              <div class="testimonial-content">
                <i class="fas fa-quote-left quote-icon"></i>
                <p>{{ t('differentials.testimonials.testimonial2.text') }}</p>
                <div class="testimonial-author">
                  <div class="author-avatar">
                    <span>{{ t('differentials.testimonials.testimonial2.authorInitials') }}</span>
                  </div>
                  <div class="author-info">
                    <h4>{{ t('differentials.testimonials.testimonial2.authorName') }}</h4>
                    <p>{{ t('differentials.testimonials.testimonial2.authorPosition') }}</p>
                  </div>
                </div>
              </div>
            </div>
          </ScrollReveal>
        </div>
      </div>
    </section> -->

    <!-- Seção CTA -->
    <section class="cta-section">
      <div class="stats-watermark stats-watermark-1"></div>
      <div class="stats-watermark stats-watermark-2"></div>
      <div class="container">
        <ScrollReveal direction="bottom" :delay="200">
          <div class="cta-content">
            <h2>{{ t('differentials.ctaTitle') }}</h2>
            <p>{{ t('differentials.ctaText') }}</p>
            <router-link to="/Contato" class="cta-button"><i class="fas fa-envelope"></i> {{ t('differentials.ctaButton') }}</router-link>
          </div>
        </ScrollReveal>
      </div>
    </section>

    <HomeFooter />
  </div>
</template>

<script>
import HomeHeader from '@/components/HomeHeader.vue';
import HomeFooter from '@/components/HomeFooter.vue';
import { useDifferentialsTranslation } from '@/composables/useDifferentialsTranslation.js';

export default {
  components: {
    HomeHeader,
    HomeFooter
  },
  setup() {
    const { t, currentLanguage } = useDifferentialsTranslation()

    return {
      t,
      currentLanguage
    }
  },
  data() {
    return {
      sidebarOpen: false
    }
  },
  methods: {
    toggleSidebar() {
      this.sidebarOpen = !this.sidebarOpen;
    }
  }
}
</script>

<style scoped>
/* Estilos Gerais */
.diferenciais-page {
  font-family: 'Matter', 'Segoe UI', Arial, sans-serif;
  color: #333;
  line-height: 1.6;
  overflow-x: hidden;
}

.container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
}

section {
  padding: 80px 0;
}

/* Hero Section com Parallax */
.hero-section {
  position: relative;
  height: 70vh;
  min-height: 500px;
  overflow: hidden;
  border-bottom: 4px solid #931414;
}

.parallax-container {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-image: url('@/assets/header-diferenciais2.jpg');
  background-size: cover;
  background-position: center;
  background-attachment: fixed;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: center;
  color: white;
}

.overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: linear-gradient(rgba(147, 20, 20, 0.7), rgba(0, 0, 0, 0.7));
}

.hero-title {
  font-size: 4rem;
  font-weight: 800;
  margin-bottom: 20px;
  position: relative;
  z-index: 2;
  text-transform: uppercase;
  letter-spacing: 2px;
  animation: fadeInUp 1.5s ease-out;
}

.hero-subtitle {
  font-size: 1.5rem;
  font-weight: 300;
  position: relative;
  z-index: 2;
  animation: fadeInUp 1.5s ease-out 0.3s both;
}

@keyframes fadeInUp {
  from {
    opacity: 0;
    transform: translateY(40px);
  }

  to {
    opacity: 1;
    transform: translateY(0);
  }
}

/* Seção de Introdução */
.intro-section {
  background-color: #f0f0f0;
  text-align: center;
  position: relative;
  overflow: hidden;
}

/* Símbolo da marca único, sangrando pela lateral esquerda */
.watermark-side {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  width: 1008px;
  height: 1008px;
  background-image: url('@/assets/uni-simbolo-outline.svg');
  background-repeat: no-repeat;
  background-position: center;
  background-size: contain;
  opacity: 0.15;
  pointer-events: none;
  z-index: 0;
}

.watermark-side-left {
  left: -399px;
  mask-image: linear-gradient(to right, rgba(0, 0, 0, 1) 0%, rgba(0, 0, 0, 0.5) 55%, transparent 85%);
  -webkit-mask-image: linear-gradient(to right, rgba(0, 0, 0, 1) 0%, rgba(0, 0, 0, 0.5) 55%, transparent 85%);
}

.intro-section .container {
  position: relative;
  z-index: 1;
}

.section-title {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 40px;
}

.section-title h2 {
  font-size: 2.5rem;
  font-weight: 700;
  color: #931414;
  margin: 0 20px;
}

.section-title.light h2 {
  color: #ffffff;
}

.accent-line {
  height: 3px;
  width: 70px;
  background-color: #931414;
}

.section-title.light .accent-line {
  background-color: #ffffff;
}

.intro-text {
  font-size: 1.3rem;
  max-width: 850px;
  margin: 0 auto;
  color: #555;
  line-height: 1.8;
}

/* Seção de Diferenciais */
.features-section {
  background: linear-gradient(315deg, #ffffff, #f0f0f0);
  position: relative;
  overflow: hidden;
}

.features-section::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-image: repeating-linear-gradient(45deg, rgba(240, 240, 240, 0.07) 0px, rgba(240, 240, 240, 0.07) 1px, transparent 1px, transparent 14px);
  opacity: 0.5;
}

/* Símbolo em bordô sangrando pelo canto inferior direito */
.features-section::after {
  content: '';
  position: absolute;
  bottom: -399px;
  right: -357px;
  top: auto;
  left: auto;
  width: 1092px;
  height: 1092px;
  background-image: url('@/assets/uni-simbolo-outline.svg');
  background-repeat: no-repeat;
  background-position: center;
  background-size: contain;
  mask-image: linear-gradient(315deg, rgba(0, 0, 0, 1) 0%, rgba(0, 0, 0, 0.5) 55%, transparent 85%);
  -webkit-mask-image: linear-gradient(315deg, rgba(0, 0, 0, 1) 0%, rgba(0, 0, 0, 0.5) 55%, transparent 85%);
  pointer-events: none;
  z-index: 0;
  opacity: 0.16;
}

.features-grid {
  display: grid;
  grid-template-columns: 1fr;
  gap: 40px;
  position: relative;
  z-index: 1;
}

.feature-card {
  display: flex;
  background: white;
  border-radius: 15px;
  overflow: hidden;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.05);
  transition: transform 0.3s ease, box-shadow 0.3s ease;
}

.feature-card:hover {
  transform: translateY(-10px);
  box-shadow: 0 15px 40px rgba(0, 0, 0, 0.1);
}

.feature-icon-wrapper {
  display: flex;
  justify-content: center;
  align-items: center;
  min-width: 120px;
  background: linear-gradient(135deg, #931414, #470404);
  color: white;
  font-size: 2.5rem;
  padding: 20px;
}

.feature-content {
  padding: 30px;
  flex: 1;
}

.feature-content h3 {
  font-size: 1.6rem;
  color: #931414;
  margin-bottom: 15px;
  font-weight: 700;
  position: relative;
  padding-bottom: 15px;
}

.feature-content h3::after {
  content: '';
  position: absolute;
  bottom: 0;
  left: 0;
  width: 50px;
  height: 3px;
  background-color: #931414;
}

.feature-content p {
  color: #696969;
  margin-bottom: 20px;
  line-height: 1.7;
}

.feature-list {
  list-style: none;
  padding: 0;
  margin: 0;
}

.feature-list li {
  position: relative;
  padding-left: 25px;
  margin-bottom: 10px;
  color: #555;
}

.feature-list li::before {
  content: '✓';
  position: absolute;
  left: 0;
  color: #931414;
  font-weight: bold;
}

.highlight {
  font-weight: 600;
  background: linear-gradient(-135deg, #300303, #931414);
  background-clip: text;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}

/* Seção de Métricas */
.metrics-section {
  background: linear-gradient(135deg, #931414, #470404);
  color: white;
  position: relative;
  overflow: hidden;
}

.metrics-section::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-image: repeating-linear-gradient(45deg, rgba(255, 255, 255, 0.08) 0px, rgba(255, 255, 255, 0.08) 1px, transparent 1px, transparent 14px);
}

/* Símbolo em branco centralizado, desvanecendo em círculo */
.metrics-section::after {
  content: '';
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 1440px;
  height: 1440px;
  background-image: url('@/assets/uni-simbolo-outline-branco.svg');
  background-repeat: no-repeat;
  background-position: center;
  background-size: contain;
  mask-image: radial-gradient(circle, rgba(0, 0, 0, 1) 0%, rgba(0, 0, 0, 0.35) 55%, transparent 80%);
  -webkit-mask-image: radial-gradient(circle, rgba(0, 0, 0, 1) 0%, rgba(0, 0, 0, 0.35) 55%, transparent 80%);
  pointer-events: none;
  z-index: 0;
  opacity: 0.12;
}

.metrics-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));
  gap: 30px;
  position: relative;
  z-index: 1;
}

.metric-card {
  background: rgba(255, 255, 255, 0.1);
  border-radius: 15px;
  padding: 30px 20px;
  text-align: center;
  backdrop-filter: blur(5px);
  transition: transform 0.3s ease, background-color 0.3s ease;
}

.metric-card:hover {
  transform: translateY(-10px);
  background: rgba(255, 255, 255, 0.2);
}

.metric-icon {
  font-size: 2.5rem;
  margin-bottom: 15px;
  color: rgba(255, 255, 255, 0.9);
}

.metric-number {
  font-size: 3rem;
  font-weight: 800;
  margin-bottom: 10px;
  background: linear-gradient(135deg, #ffffff, #f0f0f0);
  background-clip: text;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}

.metric-label {
  font-size: 1.1rem;
  font-weight: 500;
  color: rgba(255, 255, 255, 0.9);
}

/* Seção de Depoimentos */
.testimonials-section {
  background-color: #f0f0f0;
  position: relative;
  overflow: hidden;
}

.testimonials-section::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-image: repeating-linear-gradient(45deg, rgba(240, 240, 240, 0.07) 0px, rgba(240, 240, 240, 0.07) 1px, transparent 1px, transparent 14px);
  opacity: 1;
}

/* Símbolo em dourado sangrando pela borda superior */
.testimonials-section::after {
  content: '';
  position: absolute;
  top: -546px;
  left: 50%;
  transform: translateX(-50%);
  width: 1470px;
  height: 1470px;
  background-image: url('@/assets/uni-simbolo-outline-dourado.svg');
  background-repeat: no-repeat;
  background-position: center;
  background-size: contain;
  mask-image: linear-gradient(to bottom, rgba(0, 0, 0, 1) 0%, rgba(0, 0, 0, 0.4) 55%, transparent 85%);
  -webkit-mask-image: linear-gradient(to bottom, rgba(0, 0, 0, 1) 0%, rgba(0, 0, 0, 0.4) 55%, transparent 85%);
  pointer-events: none;
  z-index: 0;
  opacity: 0.14;
}

.testimonials-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: 30px;
}

.testimonial-card {
  background: white;
  border-radius: 15px;
  overflow: hidden;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.05);
  transition: transform 0.3s ease, box-shadow 0.3s ease;
  height: 100%;
}

.testimonial-card:hover {
  transform: translateY(-10px);
  box-shadow: 0 15px 40px rgba(0, 0, 0, 0.1);
}

.testimonial-content {
  padding: 30px;
  position: relative;
}

.quote-icon {
  font-size: 2rem;
  color: #931414;
  opacity: 0.2;
  position: absolute;
  top: 20px;
  left: 20px;
}

.testimonial-content p {
  font-style: italic;
  color: #555;
  margin-bottom: 20px;
  position: relative;
  z-index: 1;
  padding-left: 10px;
  padding-top: 10px;
}

.testimonial-author {
  display: flex;
  align-items: center;
}

.author-avatar {
  width: 50px;
  height: 50px;
  border-radius: 50%;
  background: linear-gradient(135deg, #931414, #470404);
  display: flex;
  justify-content: center;
  align-items: center;
  color: white;
  font-weight: 600;
  margin-right: 15px;
}

.author-info h4 {
  margin: 0;
  color: #470404;
  font-size: 1.1rem;
}

.author-info p {
  margin: 5px 0 0;
  padding-top: 0;
  color: #777;
  font-size: 0.9rem;
  font-style: normal;
}

/* Seção CTA */
.cta-section {
  background: linear-gradient(135deg, #f0f0f0, #f0f0f0);
  text-align: center;
  padding: 100px 0;
  position: relative;
  overflow: hidden;
}

/* Símbolo da marca duplicado ao fundo, desmaiado, nos dois cantos opostos —
   caixa reduzida de 1302px pra 700px (mesma proporção de recorte, só menor)
   porque essa seção é mais baixa que as outras onde esse padrão é usado */
.stats-watermark {
  position: absolute;
  top: 0;
  width: 700px;
  height: 700px;
  background-image: url('@/assets/uni-simbolo-outline.svg');
  background-repeat: no-repeat;
  background-position: center;
  background-size: contain;
  opacity: 0.16;
  pointer-events: none;
  z-index: 0;
}

.stats-watermark-1 {
  left: -181px;
  top: -203px;
  mask-image: linear-gradient(to bottom right, rgba(0, 0, 0, 1) 0%, rgba(0, 0, 0, 0.6) 55%, transparent 85%);
  -webkit-mask-image: linear-gradient(to bottom right, rgba(0, 0, 0, 1) 0%, rgba(0, 0, 0, 0.6) 55%, transparent 85%);
}

.stats-watermark-2 {
  right: -203px;
  left: auto;
  top: auto;
  bottom: -226px;
  mask-image: linear-gradient(to top left, rgba(0, 0, 0, 1) 0%, rgba(0, 0, 0, 0.6) 55%, transparent 85%);
  -webkit-mask-image: linear-gradient(to top left, rgba(0, 0, 0, 1) 0%, rgba(0, 0, 0, 0.6) 55%, transparent 85%);
}

@media (max-width: 768px) {
  .stats-watermark-2 {
    display: none;
  }
}

.cta-content {
  max-width: 700px;
  margin: 0 auto;
  position: relative;
  z-index: 1;
}

.cta-content i {
  margin-right: 8px;
}

.cta-content h2 {
  font-size: 2.5rem;
  color: #470404;
  margin-bottom: 20px;
  font-weight: 700;
}

.cta-content p {
  font-size: 1.2rem;
  color: #696969;
  margin-bottom: 30px;
}

/* .cta-button está na regra global de glass, mas o fundo aqui
   (.cta-section) é cinza claro chapado, então precisa de opacidade
   alta pra não ficar sujo/desbotado */
.cta-button {
  position: relative;
  overflow: hidden;
  display: inline-block;
  padding: 15px 40px;
  background: linear-gradient(135deg, rgba(147, 20, 20, 0.32), rgba(71, 4, 4, 0.32)) !important;
  backdrop-filter: blur(20px) saturate(200%) !important;
  -webkit-backdrop-filter: blur(20px) saturate(200%) !important;
  border: 1px solid rgba(255, 255, 255, 0.5) !important;
    -webkit-text-fill-color: #470404 !important;
  color: #470404 !important;
  text-decoration: none;
  border-radius: 50px;
  font-weight: 600;
  font-size: 1.1rem;
  transition: all 0.3s ease;
  box-shadow: 0 10px 20px rgba(147, 20, 20, 0.3), inset 0 1px 0 rgba(255, 255, 255, 0.3);
}

.cta-button::before {
  content: '';
  position: absolute;
  inset: 0;
  background: linear-gradient(180deg, rgba(255, 255, 255, 0.3) 0%, transparent 60%);
  pointer-events: none;
}

.cta-button i {
  position: relative;
    -webkit-text-fill-color: #470404 !important;
  color: #470404 !important;
}

.cta-button:hover {
  transform: translateY(-5px);
  box-shadow: 0 15px 30px rgba(147, 20, 20, 0.4);
}

/* Responsividade */
@media (max-width: 1200px) {
  .container {
    padding: 0 40px;
  }
}

@media (max-width: 1049px) {
  .metrics-grid {
    grid-template-columns: 1fr 1fr;
  }
}

@media (max-width: 992px) {
  .hero-title {
    font-size: 3rem;
  }

  .hero-subtitle {
    font-size: 1.3rem;
  }

  section {
    padding: 60px 0;
  }

  .feature-card {
    flex-direction: column;
  }

  .feature-icon-wrapper {
    min-width: 100%;
    padding: 30px 0;
  }
}

@media (max-width: 768px) {
  .hero-section {
    height: 60vh;
    min-height: 400px;
  }

  .hero-title {
    font-size: 2.5rem;
  }

  .section-title h2 {
    font-size: 2rem;
  }

  .intro-text {
    font-size: 1.1rem;
  }

  .metrics-grid {
    grid-template-columns: repeat(2, 1fr);
  }

  .cta-content h2 {
    font-size: 2rem;
  }
}

@media (max-width: 576px) {
  .container {
    padding: 0 20px;
  }

  .hero-title {
    font-size: 2rem;
  }

  .hero-subtitle {
    font-size: 1.1rem;
  }

  .section-title h2 {
    font-size: 1.8rem;
  }

  .accent-line {
    width: 40px;
  }

  .metrics-grid {
    grid-template-columns: 1fr;
  }

  .cta-button {
    padding: 12px 30px;
    font-size: 1rem;
  }
}

/* Animações adicionais */
@keyframes float {
  0% {
    transform: translateY(0px);
  }

  50% {
    transform: translateY(-10px);
  }

  100% {
    transform: translateY(0px);
  }
}

.feature-icon-wrapper i,
.metric-icon i {
  animation: float 3s ease-in-out infinite;
}

.feature-card:hover .feature-icon-wrapper {
  background: linear-gradient(135deg, #470404, #931414);
}

.metric-card:hover .metric-icon {
  transform: scale(1.1);
  transition: transform 0.3s ease;
}

.testimonial-card:hover .quote-icon {
  opacity: 0.4;
  transition: opacity 0.3s ease;
}

.feature-list li:hover::before {
  transform: scale(1.2);
  transition: transform 0.3s ease;
}

.feature-list li:hover .highlight {
  color: #931414;
  transition: color 0.3s ease;
}

/* Animação para o botão CTA */
@keyframes pulse {
  0% {
    box-shadow: 0 0 0 0 rgba(147, 20, 20, 0.7);
  }

  70% {
    box-shadow: 0 0 0 10px rgba(147, 20, 20, 0);
  }

  100% {
    box-shadow: 0 0 0 0 rgba(147, 20, 20, 0);
  }
}

.cta-button:hover {
  animation: pulse 1.5s infinite;
}

/* Ajustes para dispositivos móveis */
@media (max-width: 480px) {
  .hero-title {
    font-size: 1.8rem;
  }

  .hero-subtitle {
    font-size: 1rem;
  }

  .feature-content h3 {
    font-size: 1.4rem;
  }

  .metric-number {
    font-size: 2.5rem;
  }

  .testimonial-content {
    padding: 20px;
  }

  .author-avatar {
    width: 40px;
    height: 40px;
    font-size: 0.8rem;
  }

  .author-info h4 {
    font-size: 1rem;
  }
}
</style>
